<div class='timeline-cover'>
  <div id='draggable'></div>
  <div class='timeline-bar'>
    <div class='steps-bar clearfix'></div>
  </div>
</div>